import React from "react";
import PredictionPage from "../../components/PredictionPage";

function AUDCAD() {
  return (
    <PredictionPage
      title="AUDCAD"
      content="This is the AUDCAD AI Trading Predictions page."
      canonical="/forex-minors/audcad-ai-trading-predictions"
      categoryKey="nav.forexMinors"
      categoryPath="/forex-minors"
      symbol="AUDCAD"
    />
  );
}

export default AUDCAD;
